module.exports = __webpack_public_path__ + "prod/1.42.2/img/input-icon-phone.7705abe0.svg";